import React from "react";
import { useSelector, useDispatch } from "react-redux";
import AccountSidebar from "../../components/Account/SIdebar";
import userImg from '../../assets/images/user-img.webp';
import { Link } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";


const MyAccount = () => {
  const user = useSelector((state) => state.user.currentUser);


  console.log(user, 'user')

  return (
    <>
     <Breadcrumb activeName={"My Account"} middleName={""} middleUrl={""}/>
      <section className="account-section">
        <div className="container">
          <div className="row">
            <div className="col-full">
              <div className="account-data">
                <AccountSidebar />
                <div className="single-account-dashboard-data">
                  <div className="single-account-wrapper">
                    <h2 className="tabcontent-title">My Account</h2>
                        
                    <div className="account-profile text-center">
                      <div className="img-area">
                        <div className="inner-area">
                            <img
                            height="100"
                            width="100"
                            src={userImg} 
                            alt="user name"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                      
                      
                      <div className="profile-data">
                        <h5 className="username">{user?.username}</h5>
                        <p className="profile-info">{user?.number}</p>
                        <p className="profile-info">{user?.email}</p>
                        <div className="profile-edit"><Link href="/my-account/my-profile"><i className="fa fa-edit"></i></Link></div>
                      </div>
                    </div>
                    <div className="simplified_main-box">
                    <div className="card">
                        <div className="card-title">
                          <div className="card-icon">
                            <i className="fa fa-key" aria-hidden="true"></i>
                          </div>
                          <h5 className="card-name">Update Profile</h5>
                        </div>
                        <div className="card-info">
                          <Link to="/my-profile" className="card-link">
                            View Now
                          </Link>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-title">
                          <div className="card-icon">
                          <i className="fa fa-list-alt" aria-hidden="true"></i>
                          </div>
                          <h5 className="card-name">Saved Address</h5>
                        </div>
                        <div className="card-info">
                          <Link to="/my-account/saved-address" className="card-link">
                            View Now
                          </Link>
                        </div>
                      </div>
                      <div className="card">
                        <div className="card-title">
                          <div className="card-icon">
                            <i className="fa fa-cubes" aria-hidden="true"></i>
                          </div>
                          <h5 className="card-name">Order`s Manage</h5>
                        </div>
                        <div className="card-info">
                          <Link to="/my-orders" className="card-link">
                            View Now
                          </Link>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MyAccount;
